/**
 * Merges runtime meta for rules/effects/validation.
 * `modeName` (resolved FormRenderer mode) MUST win over compose meta.mode.
 */
export function mergeFormEngineMeta(
  modeName: string,
  externalMeta: Record<string, unknown> = {},
  stepMeta: Record<string, unknown> = {},
  env: string | undefined = process.env.REACT_APP_ENVIRONMENT,
): Record<string, unknown> {
  return {
    env,
    ...externalMeta,
    ...stepMeta,
    mode: modeName,
  };
}
